import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import { Query, useMutation } from 'react-apollo';
import Table from '@material-ui/core/Table';
import MaterialTable from 'material-table';
import { GET_BONUS_HISTORY } from 'graphql/payments';
import { getFullName, formatCurrency } from 'utils';

const BonusLogs = ({ userId }) => {
  const columns = [
    {
      title: 'Date',
      field: 'date',
      type: 'date',
    },
    {
      title: 'Duration - min',
      field: 'duration',
    },
    {
      title: 'Amount',
      field: 'total',
      render: (row) => formatCurrency(row.total / 100),
    },
    {
      title: 'Status',
      field: 'status',
    },
    {
      title: 'Payment Status',
      render: (row) =>
        row.payment_invoice ? row.payment_invoice.status : 'Not Paid',
    },
    {
      title: 'Comments',
      field: 'comments',
    },
  ];

  const renderDetails = (row) => {
    return (
      <MaterialTable
        style={{
          backgroundColor: '#f8f8f8'
        }}
        options={{
          toolbar: false,
          paging: false,
        }}
        columns={[
          {title: 'Student', render: row => getFullName(row.student)},
          ...columns
        ]}
        data={row.payment_line_items}
      />
    );
  };

  return (
    <Box>
      <Query query={GET_BONUS_HISTORY} variables={{ userId }}>
        {({ data, loading }) => {
          return (
            <MaterialTable
              isLoading={loading}
              columns={columns}
              data={data?.rows}
              options={{
                toolbar: false,
                paging: false,
              }}
              detailPanel={renderDetails}
              onRowClick={(event, rowData, togglePanel) => togglePanel()}
            />
          );
        }}
      </Query>
    </Box>
  );
};

export default BonusLogs;
